import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { Menu, Paper } from '@material-ui/core'
import mapService from './paidLeaveMapService'
import * as contextModule from '../../../context/paidLeaveContext'
import Choropleth, {
  getStrokeByPaidLeave,
  getFillByPaidLeave
} from '../../../common/components/drawMap'
import { tooltipText } from './tooltipTemplate'
import { GraphHeading, StyledHeaderSpan, StyledMenuHeader, StyledMenuItem, StyledRightButton, TileStyle } from '../../../theme/Global'
import { PaidLeaveMapIcon } from './styles'
import { usStates } from '../../../constants/localeNames'

const PaidLeaveMapRenderer = ({ companyId }) => {
  const history = useHistory()
  const { paidLeaveData } = contextModule.usePaidLeave()
  const [mapData, setMapData] = useState([])
  const [loading, setLoading] = useState(true)
  const [locationMenuAnchor, setLocationMenuAnchor] = useState(null)

  const selectedCountry = 'US'

  const openLocationMenu = (e) => {
    setLocationMenuAnchor(e.currentTarget)
  }

  const closeLocationMenu = (e) => {
    setLocationMenuAnchor(null)
  }

  const getCountryCode = (datum) => {
    const prCode = datum.properties.GID_0 === 'PRI' ? 'PR' : null
    const viCode = datum.properties.adm0_a3 === 'VIR' ? 'VI' : null
    const guCode = datum.properties.GID_0 === 'GUM' ? 'GU' : null
    return datum.properties.iso_a2 || prCode || viCode || guCode
  }

  const onMapClick = (event) => {
    const country = getCountryCode(event)
    const state = event.properties.postal ? event.properties.postal : country
    history.push(`/paidLeave/locations?state=${state}&country=${country}`)
  }

  useEffect(() => {
    let subscribed = true
    if (subscribed) {
      setLoading(true)
      mapService.getMapData(companyId)
        .then((mapDataResultSet) => {
          if (subscribed) {
            setMapData(mapDataResultSet)
            setLoading(false)
          }
        })
    }
    return () => { subscribed = false }
  }, [paidLeaveData])

  return (
    <Paper style={TileStyle} data-testid="paid-leave-map">
      <GraphHeading>
        <StyledHeaderSpan>
          <PaidLeaveMapIcon />
          {' '}
          Paid Leave Type by State
        </StyledHeaderSpan>
        <StyledRightButton onClick={openLocationMenu}>Select Location</StyledRightButton>
        <Menu
          anchorEl={locationMenuAnchor}
          open={Boolean(locationMenuAnchor)}
          onClose={closeLocationMenu}
          PaperProps={{
            style: {
              maxHeight: 100 * 4.5,
              width: '20ch'
            }
          }}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left'
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left'
          }}
          getContentAnchorEl={null}
        >
          <StyledMenuHeader
            key="United States"
            country="US"
            disabled
          >
            US States
          </StyledMenuHeader>
          {usStates.map((location) => (
            <StyledMenuItem
              key={location.name}
              country={location.localeRegion}
              onClick={() => {
                closeLocationMenu()
                history.push(`/paidLeave/locations?state=${location.localeID}&country=${location.localeRegion}`)
              }}
            >
              {location.name}
            </StyledMenuItem>
          ))}
        </Menu>
      </GraphHeading>
      <Choropleth
        data-testid="paidLeave-Choropleth"
        getDomainSpan={[0, 0]}
        onMapClick={onMapClick}
        mapData={mapData}
        country={selectedCountry.code}
        getStrokeForState={getStrokeByPaidLeave}
        getFillForState={getFillByPaidLeave}
        getTooltipHtml={tooltipText}
        parentIsLoading={loading}
      />
    </Paper>
  )
}

export default PaidLeaveMapRenderer
